export function IconTag() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path fill="currentColor" d="M6.589 2.7a.25.25 0 0 0-.169-.074L2.76 2.5a.25.25 0 0 0-.259.259l.126 3.661a.25.25 0 0 0 .074.169l2.903 2.903a.25.25 0 0 0 .353 0l3.536-3.536a.25.25 0 0 0 0-.353L6.589 2.7zm-.117-1.573a1.75 1.75 0 0 1 1.177.512l2.904 2.903a1.75 1.75 0 0 1 0 2.475l-3.536 3.535a1.75 1.75 0 0 1-2.475 0L1.64 7.65a1.75 1.75 0 0 1-.512-1.177L1.001 2.81a1.75 1.75 0 0 1 1.81-1.809l3.661.126z"/>
            <path fill="currentColor" d="M5.25 3.835a1 1 0 1 1-1.415 1.414 1 1 0 0 1 1.414-1.414z"/>
        </svg>
    );
}
